import { AvatarDropdown as CoreAvatarDropdown } from '@zhiyue/core';
import { BizAppConfig } from 'config/application.manifest';
import React from 'react';

const AvatarDropdown: React.FC = () => {
  return (
    <CoreAvatarDropdown
      appId={BizAppConfig.appSsoClientId}
      personalCenterUrl={BizAppConfig.appPersonalCenterUrl}
      tenantManagementUrl={BizAppConfig.appTenantManagementUrl}
      workbenchUrl={BizAppConfig.appWorkbenchUrl}
      openPlatformUrl={''}
      feedbackUrl={''}
    />
  );
};

export default AvatarDropdown;
